import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { environment } from '../../environments/environment';
import { AdminUser } from "../_model/user/admin-user";
import { User } from '../_model/user/user';
import { map } from 'rxjs/operators'; 
import { FaqResponse } from "../_model/faq/faq-reponse";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly CURRENT_USER = 'currentUser';

  constructor(private http: HttpClient) {
  }

  getBaseUrl() {
    return environment.baseUrl + '/api/gateway/v1';
  }

  getClientBaseUrl() {
    return this.getBaseUrl() + '/fmSystem/' + this.getFmSystemId() +'/clients/' + this.getClientId();
  }

  getClientBaseNewUrl() {
    return this.getBaseUrl() + '/brand/' + this.getBrand() + '/fmSystem/' + this.getFmSystemId() +'/clients/' + this.getClientId();
  }

  getClientAndFmSystemBaseUrl() {
    return this.getBaseUrl() + '/fmSystem/' + this.getFmSystemId() +'/client/' + this.getClientId();
  }

  getClientUrl() {
    return this.getBaseUrl() +'/clients/' + this.getClientId();
  }

  getFmSystemUrl(){
    return '/fmSystem/' + this.getFmSystemId();
  }

  public getUser(): User {
    if(sessionStorage.getItem(this.CURRENT_USER)){
      return JSON.parse(sessionStorage.getItem(this.CURRENT_USER)!);
    }
      return JSON.parse(localStorage.getItem(this.CURRENT_USER)!);  
  }

  public updateLocalUser(user: User) {
    localStorage.setItem('currentUser',JSON.stringify(user));
    sessionStorage.setItem('currentUser', JSON.stringify(user));
  }

  getClientId(): string {
    return this.getUser().clientId;
  }

  getBrand(): string {
    return this.getUser().brand;
  }

  updateClient(adminUser: AdminUser): Observable<any> {
    return this.http.put<any>(this.getBaseUrl() + "/user", adminUser);
  }

  getFmSystemId(): string {
      return this.getUser().fmSystemId;
  }

  updateFmSystemList(adminUser: AdminUser): Observable<any> {
      return this.http.put<any>(this.getBaseUrl() + "/user", adminUser);
  }

  getFaq(): Observable<Blob> {
    const faqUrl = this.getBaseUrl() + '/faq';
    return this.http.get<FaqResponse>(faqUrl) // JSON response
      .pipe(
        map((response: FaqResponse) => {
          const base64Data = response.data.fileContent;
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          return new Blob([byteArray], { type: 'application/pdf' });
        })
      );
  }
}
